import {
  CATEGORY_ARBEITSSICHERHEIT_ID,
  CATEGORY_BETRIEBSMEDIZIN_ID,
} from "@/helper/categoryIds";

export type LmsCourseCategoryPresentation = {
  color: string;
};

const ARBEITSSICHERHEIT_PRESENTATION: LmsCourseCategoryPresentation = {
  color: "#8C1EC8",
};

const BETRIEBSMEDIZIN_PRESENTATION: LmsCourseCategoryPresentation = {
  color: "#FF6428",
};

const DEFAULT_PRESENTATION: LmsCourseCategoryPresentation = {
  color: "#008C7D",
};

export type LmsCourseCategoryRef =
  | {
      id?: string | null;
      value?: string | null;
    }
  | string
  | null;

export const getLmsCourseCategoryId = (
  category?: LmsCourseCategoryRef,
): string => {
  if (typeof category === "string") {
    return category.trim();
  }

  return String(category?.id ?? category?.value ?? "").trim();
};

export const getLmsCourseCategoryPresentation = (
  category?: LmsCourseCategoryRef,
): LmsCourseCategoryPresentation => {
  const categoryId = getLmsCourseCategoryId(category).toLowerCase();

  if (categoryId === CATEGORY_BETRIEBSMEDIZIN_ID) {
    return BETRIEBSMEDIZIN_PRESENTATION;
  }

  if (categoryId === CATEGORY_ARBEITSSICHERHEIT_ID) {
    return ARBEITSSICHERHEIT_PRESENTATION;
  }

  return DEFAULT_PRESENTATION;
};
